import neebsSmall from '../images/ark-sm.jpg';
import musicSmall from '../images/music-sm.jpg'
import beehiveSmall from '../images/dev-group-sm.jpg'
import skateSmall from '../images/skate-sm.jpg'
import vortexSmall from '../images/vortex-sm.jpg'
import todoApp from '../images/todos-sm.jpg'
import commentsApp from '../images/comments-sm.jpg';
import gitHubSearchApp from '../images/github-search-75.jpg';
import staffListing from '../images/staff-listing-75.jpg';
import dictionary from '../images/dictionary.jpg';


export const caseStudies = [
    {
        name: "dictionary",
        title: "Dictionary App",
        subtitle: "A Frontend Mentor challenge",
        imgSmall: dictionary,
        href: "/dictionary"
    },
    {
        name: "staff-listing",
        title: "Staff Listing",
        subtitle: "A flexible component using container queries",
        imgSmall: staffListing,
        href: "/staff-listing"
    },
    {
        name: "github",
        title: "GitHub User Search",
        subtitle: "A Frontend Mentor challenge",
        imgSmall: gitHubSearchApp,
        href: "/github-user-search"
    },
    {
        name: "comments",
        title: "Comments Section",
        subtitle: "A Frontend Mentor challenge",
        imgSmall: commentsApp,
        href: "/interactive-comments-section"
    },
    {
        name: "todos",
        title: "Your Daily Todos",
        subtitle: "A Frontend Mentor challenge",
        imgSmall: todoApp,
        href: "/your-daily-todos"
    },
    {
        name: "vortex",
        title: "The Vortex Project",
        subtitle: "The ultimate Doctor Who experiance",
        imgSmall: vortexSmall,
        href: "/the-vortex"
    },
    {
        name: "neebs",
        title: "Neebs Gaming",
        subtitle: "The best gaming channel in the world",
        imgSmall: neebsSmall,
        href: "/neebs-gaming",
    },
    {
        name: "music",
        title: "The Music Shop",
        subtitle: "An exploration of sass and netlify",
        imgSmall: musicSmall,
        href: "/the-music-shop"
    },
    {
        name: "beehive",
        title: "The Beehive",
        subtitle: "A project for inclusion",
        imgSmall: beehiveSmall,
        href: "/the-beehive"
    },
    {
        name: "skate",
        title: "The Skate Shop",
        subtitle: "An exploration of layout",
        imgSmall: skateSmall,
        href: "/the-skate-shop"
    }

]